import React from "react";

interface ConfirmationModalProps {
    onDelete: (param1?: any, param2?: any) => void;
    isOpen: boolean;
    onClose: () => void;
    title: string;
    type: string;
    inputtedData: any;
    isSelectEan: any;
}


const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    onDelete,
    isOpen,
    onClose,
    title,
    type,
    inputtedData,
    isSelectEan
}) => {

    console.log("inputtedData",inputtedData)
    console.log("isSelectEan",isSelectEan)

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
                    <div className="relative bg-white p-8 rounded-lg shadow-lg w-[450px]  max-w-full">
                        {/* Cross button */}
                        <button
                            className="absolute top-2 right-4 border-none bg-white text-gray-600 hover:text-gray-800 cursor-pointer"
                            onClick={onClose}
                        >
                            <span className="text-3xl">&times;</span> {/* Cross icon */}
                        </button>

                        {/* Modal Content */}
                        <div className="flex flex-col">

                            <span className="text-xl font-semibold text-gray-800 text-center">{title}</span>
                            <span className="mt-2 text-gray-600 text-center">Are you sure you want to continue?</span>
                        </div>
                        <div className="mt-4 flex justify-center space-x-2"> {/* Center align the buttons */}
                            <button
                                // className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 focus:outline-none"
                                className="flex font-poppins  rounded-lg cursor-pointer justify-start px-4 py-2  border border-none bg-gray-300 text-gray-700 hover:bg-gray-400"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                            <button
                                // className="px-4 py-2 bg-[#E31c23] text-white rounded-lg hover:bg-red-600 focus:outline-none transition-colors duration-200 active:bg-[#F87171]"
                                className={`flex font-poppins text-white rounded-lg cursor-pointer justify-start px-4 py-2  border border-none bg-[#e31c23] disabled:bg-[#f87171] hover:bg-red-700`}
                                onClick={onDelete}
                            >{type === "delete" ? "Delete" : type === "continue" ? "Continue" : "Clear"}

                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ConfirmationModal;
